import { useState, useCallback } from 'react'

const storageName = 'baseName'

export const useBase = () => {
    const [base, setBase] = useState(() => localStorage.getItem(storageName) || null)

    const selectBase = useCallback((id) => {
        localStorage.setItem(storageName, id)
        setBase(id)
    }, [])

    const clearBase = useCallback(() => {
        localStorage.removeItem(storageName)
        setBase(null)
    }, [])

    return { base, selectBase, clearBase }
}